import { createAction } from '@reduxjs/toolkit'

export const fetchAdPackages = createAction('adPackages/fetchAdPackages')
export const updateAdPackage = createAction('adPackages/updateAdPackage')
export const createAdPackage = createAction('adPackages/createAdPackage')
export const deleteAdPackage = createAction('adPackages/deleteAdPackage')
export const duplicateAdPackage = createAction('adPackages/duplicateAdPackage')
